import React from "react";
import {
    BlockTitle, f7,
    List,
    ListItem,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    Page
} from "framework7-react";
import iride_logo from "./assets/iride_logo.png";
import {IWLocalAutocomplete} from "./IWComponents";
import Destinazioni from "./entities/Destinazioni";

export default class Destinazione extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            destinazioni: [],
        };
        this.openMapUrl = this.openMapUrl.bind(this);
    }

    socioChanged = async (event) => {
        const anag = event.target?.value;
        if (anag) {
            const {idanagrafica} = anag;
            const dest = await new Destinazioni();
            const destinazioni = await dest.getByIdAnagrafica(idanagrafica);
            this.setState({destinazioni: destinazioni.docs || []});
        }
    }

    openMapUrl = (d) => {
        const {indirizzo} = d;
        f7.dialog.confirm('Avviare la navigazione verso ' + indirizzo + "?", 'Attenzione', () => {
            window.open('ext://https://www.google.com/maps/search/?api=1&query=' + d.latitudine + ',' + d.longitudine, '_system');
        });
    }


    render() {
        const self = this;
        return (
            <Page name="destinazione">
                <Navbar>
                    <NavLeft backLink="Back" backLinkForce backLinkUrl={"/home/"}/>
                    <NavTitle><img src={iride_logo} alt='logo' height="30rem"/>{"Ricerca Destinazione"}</NavTitle>
                    <NavRight/>
                </Navbar>
                <BlockTitle strong>Ricerca Destinazione</BlockTitle>
                <List className={"no-margin no-padding"}>
                    <IWLocalAutocomplete
                        title={"Socio"}
                        id={"anagrafica"}
                        type={"Soci"}
                        onChange={this.socioChanged.bind(this)}
                        autofocus={true}
                    />
                </List>
                {self.state.destinazioni.length > 0 && (
                    <>
                        <BlockTitle>Destinazioni</BlockTitle>
                        <List dividersIos mediaList outlineIos strongIos>
                            {self.state.destinazioni.map((destinazione, i) => {
                                return (
                                    <ListItem link="#"
                                              key={"destinazione_" + i}
                                              title={"Sede " + (parseInt(destinazione.nsede) + 1).toString()}
                                              subtitle={destinazione.latitudine + " - " + destinazione.longitudine}
                                              text={destinazione.indirizzo}
                                              onClick={() => this.openMapUrl(destinazione)}
                                    />
                                )
                            })}
                        </List>
                    </>
                )}
                <List>

                </List>
            </Page>
        )
    }

}